const DEFAULT_SIZES = {
  width: 101.6,
  height: 120,
  padding: {
    top: 66.7,
    bottom: 14.3,
    left: 10,
    right: 10,
  },
  fontSize: 17,
  fontWeight: "normal",
};

export const printTicket = (ticket) => {
  const sizes = DEFAULT_SIZES;

  const printContent = `
        <!DOCTYPE html>
        <html>
        <head>
          <title>Ticket - ${ticket.firstName} ${ticket.lastName}</title>
          <style>
            @page {
              size: ${sizes.width}mm ${sizes.height}mm;
              margin: 0;
            }
            
            body {
              font-family: "Myriad Pro Condensed", Arial, sans-serif;
              margin: 0;
              padding: ${sizes.padding.top}mm ${sizes.padding.right}mm ${sizes.padding.bottom}mm ${sizes.padding.left}mm;
              background: white;
              width: ${sizes.width}mm;
              height: ${sizes.height}mm;
              box-sizing: border-box;
              overflow: hidden;
            }
            
            .ticket-container {
              margin: 0 auto;
              display: flex;
              align-items: center;
              justify-content: center;
              width: 100%;
            }
            
            .ticket-name {
              font-size: ${sizes.fontSize}pt;
              font-weight: ${sizes.fontWeight};
              text-align: center;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              max-width: 100%;
            }
          </style>
        </head>
        <body>
          <div class="ticket-container">
            <div class="ticket-name">
              ${ticket.firstName} ${ticket.lastName}
            </div>
          </div>
        </body>
        </html>
      `;

  // A hidden iframe prints without a popup, so it isn't blocked when the print
  // is triggered programmatically (the auto-print countdown) rather than by a
  // click, and window.print() inside it is silent under the kiosk flag.
  const iframe = document.createElement("iframe");
  iframe.style.position = "fixed";
  iframe.style.width = "0";
  iframe.style.height = "0";
  iframe.style.border = "0";

  const cleanup = () => {
    if (iframe.parentNode) iframe.parentNode.removeChild(iframe);
  };

  // Attach onload and set the markup via srcdoc before inserting the iframe, so
  // the single load event carries the ticket content. Writing after append would
  // let the initial about:blank load fire print() on an empty document.
  iframe.onload = () => {
    const frameWindow = iframe.contentWindow;
    frameWindow.focus();
    frameWindow.print();
    frameWindow.onafterprint = cleanup;
    setTimeout(cleanup, 60000);
  };

  iframe.srcdoc = printContent;
  document.body.appendChild(iframe);
};
